const Globalize = require('globalize');

const locales = process.env.RIOT_LOCALES.split(',');
const shard = process.env.RIOT_SHARD;

class I18n {
  constructor() {
    Globalize.locale(this.currentLanguage());
  }

  setTranslations(translations) {
    this.translations = translations;
  }

  currentShard() {
    return shard;
  }

  languageFromLocale(locale) {
    return locale.split('_')[0];
  }

  localeFromLanguage(language) {
    return locales.find(locale => {
      return language === this.languageFromLocale(locale);
    });
  };

  currentLanguage() {
    let language = window.location.pathname.slice(1).split('/')[0];

    if(language.length > 0 && this.localeFromLanguage(language)) {
      return language;
    } else {
      language = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
      language = language.split('-')[0];

      return this.localeFromLanguage(language) ? language : this.languageFromLocale(locales[0]);
    }
  }

  currentLocale(language = this.currentLanguage()) {
    return this.localeFromLanguage(language);
  };

  loadTranslation(locale = this.currentLocale()) {
    return new Promise((resolve, reject) => {
      require('bundle-loader?lazy!./languages/' + locale + '.json')((t) => {
        this.translations = t;
        resolve(t);
      });
    });
  }

  loadFooter(locale = this.currentLocale()) {
    return new Promise((resolve, reject) => {
      require('bundle-loader?lazy!./footers/' + shard + '/' + locale + '.html')((t) => {
        this.footer = t;
        resolve(t);
      })
    });
  }

  // globalize-compiler can't handle variable arguments, so unfortunately we must have
  // formatter functions for every distinct type of numeric format we want to support, i.e.
  // these functions can't take an options param to pass to globalize because it breaks
  // the compiler (which is what allows us to build a minimal subset of the cldr data).
  // context: https://github.com/globalizejs/globalize-compiler/issues/10#issuecomment-173571256
  number(number = 0) {
    return Globalize.formatNumber(number);
  }

  ms(number = 0) {
    // return Globalize.formatUnit(number, 'millisecond', { form: 'short'} );
    return this.number(number) + ' ' + this.t('units.milliseconds');
  }

  percent(number = 0) {
    return Globalize.formatNumber(number / 100, { style: 'percent', maximumFractionDigits: 2, minimumFractionDigits: 0 });
  }

  fractionalPercent(number = 0) {
    return Globalize.formatNumber(number / 100, { style: 'percent', maximumFractionDigits: 2, minimumFractionDigits: 2 });
  }

  t(key) {
    return (this.translations[key] || key).replace('<a href', '<a target="_blank" href');
  }

  time(seconds) {
    var hours = seconds / 3600
    var minutes = (seconds - (hours * 3600)) / 60
    if (shard === 'na') {
      var suffix = 'AM'
      if (hours > 11) {
        hours -= 12
        suffix = 'PM'
      }
      if (hours === 0) {
        hours = 12
      }
      return `${hours}${minutes !== 0? `:${minutes.toString(10).length === 1? `0${minutes.toString(10)}` : minutes.toString(10)}` : ''}${suffix}`
    } else {
      return `${hours}:${minutes.toString(10).length === 1? `0${minutes.toString(10)}` : minutes.toString(10)}`
    }
  }

  getFooter() {
    return this.footer;
  }

  has(key) {
    return Object.keys(this.translations).indexOf(key) >= 0;
  }

  country(code) {
    return this.translations[`countries.${code}`] || code;
  }

  scoped(basePath = '') {
    const path = (key = '') => {
      return key.length === 0 ? basePath : (basePath.length === 0 ? key : `${basePath}.${key}`);
    };

    const t = (key, scoped = true) => {
      return this.t((scoped ? path(key) : key), this.translations);
    };

    return {
      t,
      getFooter: () => this.getFooter(),
      replace: (key, replacements, scoped = true) => {
        let string = t(key, scoped);

        Object.keys(replacements).forEach(key => {
          string = string.replace(key, replacements[key]);
        });

        return string;
      },
      has: (key) => {
        return this.has(path(key), this.translations);
      },
      country: (country_code) => this.country(country_code),
      path,
      unit: (number, unit) => this.unit(number, unit),
      number: (number) => this.number(number),
      percent: (number) => this.percent(number),
      fractionalPercent: (number) => this.fractionalPercent(number),
      time: (seconds) => this.time(seconds),
      ms: (number) => this.ms(number)
    };
  }
}

export default new I18n();



// WEBPACK FOOTER //
// ./src/i18n/index.js